import { CustomizationFlagTypes, useCustomizationFlagShallowStore } from '@frontend/api-customization-flags';
import { useHasFeatureFlag } from '@frontend/shared';
import { featureFlags } from '../../../feature-flags';

export const useShowMissedCallTextRoiWidget = () => {
  const { flags } = useCustomizationFlagShallowStore('flags');
  const isCFEnabled = flags.missedcalltext?.state === CustomizationFlagTypes.CustomizationFlagState.ACTIVE;
  const isFFEnabled = useHasFeatureFlag(featureFlags.missexCallTextROIWidget);

  return isCFEnabled && isFFEnabled;
};
